import { render, staticRenderFns } from "./notifications-push.vue?vue&type=template&id=73475ac2&scoped=true"
import script from "./notifications-push.vue?vue&type=script&lang=ts"
export * from "./notifications-push.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "73475ac2",
  null
  
)

export default component.exports